package app.nestbridge.feature.main.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data object MainShellScreen : Screen

enum class MainTab {
    HOME,
    CHILDREN,
    MESSAGES,
    PROGRESS,
}

data class MainShellState(
    val selectedTab: MainTab,
    val profilePictureUrl: String? = null,
    val userName: String? = null,
    val eventSink: (MainShellEvent) -> Unit,
) : CircuitUiState

sealed interface MainShellEvent {
    data class TabSelected(val tab: MainTab) : MainShellEvent
    data object ProfileClicked : MainShellEvent
}
